
//project1
import project1Thumbnail from "./assets/project-cover-1.jpg";
import project1Image1 from './assets/project1/1.jpg';
import project1Image2 from './assets/project1/2.jpg';
import project1Image3 from './assets/project1/3.jpg';
import project1Image4 from './assets/project1/4.jpg';
import project1Image5 from './assets/project1/5.jpg';
import project1Image6 from './assets/project1/6.jpg';
import project1Image7 from './assets/project1/7.jpg';
import project1Image8 from './assets/project1/8.jpg';

//project2
import project2Thumbnail from "./assets/project-cover-2.jpg";
import project2Image1 from './assets/project2/1.jpg';
import project2Image2 from './assets/project2/2.jpg';
import project2Image3 from './assets/project2/3.jpg';
import project2Image4 from './assets/project2/4.jpg';
import project2Image5 from './assets/project2/5.jpg';
import project2Image6 from './assets/project2/6.jpg';
import project2Image7 from './assets/project2/7.jpg';
import project2Image8 from './assets/project2/8.jpg';

//project3
import project3Thumbnail from "./assets/project-cover-3.jpg";
import project3Image1 from './assets/project3/1.jpg';
import project3Image2 from './assets/project3/2.jpg';
import project3Image3 from './assets/project3/3.jpg';
import project3Image4 from './assets/project3/4.jpg';
import project3Image5 from './assets/project3/5.jpg';
import project3Image6 from './assets/project3/6.jpg';
import project3Image7 from './assets/project3/7.jpg';
import project3Image8 from './assets/project3/8.jpg';
import project3Image9 from './assets/project3/9.jpg';
import project3Image10 from './assets/project3/10.jpg';



const projectsInfo = [
    {
        id: '23',
        title: 'ECHOES OF PRESENCE',
        thumbnail: project1Thumbnail,
        subtitle:
            'Împreună înseamnă multe lucruri.',
        creditsTo: 'Rizescu Alina',
        description:
            'Împreună nu înseamnă neapărat în același loc. Amprenta pe care oamenii o lasă asupra spațiului comun este o formă dinamică de împreună.<br/> Echoes of Presence este o instalație imersivă în care prezența vizitatorilor influențează ambientul și experiența celorlalți.<br/> Aceștia parcurg un traseu prin 3 încăperi în care experiențele vizuale se combină cu cele sonore și cu cele senzoriale.<br/> Prin senzori de prezență vizitatorii declanșează efecte care se propagă dintr-o încăpere în cealaltă. Parcursul este o descoperire a celuilalt, din ce în ce mai profundă.<br/> A auzi, a simți și a cunoaște sunt temele celor 3 camere în care omul este surprins de un ambient în continuă schimbare.<br/> Scenografia amintește de un context urban esențializat, percepția asupra spațiului este augmentată prin reflexii și tehnologie.',
        imageCollection: [
            project1Image1,
            project1Image2,
            project1Image3,
            project1Image4,
            project1Image5,
            project1Image6,
            project1Image7,
            project1Image8
        ]
    },
    {
        id: '8',
        title: 'TOGETHERNESS',
        thumbnail: project2Thumbnail,
        subtitle:
            'O expoziție în 4 spații, care încurajează oamenii împreună la reflexie și joacă într-un spațiu dedicat conexiunii cu sinele, dar și cu comunitatea. ',
        creditsTo: 'Damir Iuliana',
        description:
            'Expoziția cu titlul “TOGETHERNESS” este un proiect desfășurat în cadrul Romanian Design Week 2023, în parteneriat cu IQOS, tema din acest an fiind RE-CONNECT “A celebration of togetherness”. Așadar, expoziția desfășurată în 4 spații și 115mp are ca scop atragerea oamenilor împreună la reflexie și joacă într-un spațiu dedicat conexiunii cu sinele, dar și cu comunitatea. Acest lucru este posibil doar prin înțelegerea felului în care funcționăm, a emoțiilor noastre, dar și cum interacționăm cu ceilalți într-un mod empatic și conștient. Având aceste elemente ca principali directori de organizare conceptuală și spațială, proiectul s-a conturat prin integrarea a două teorii: Harvard Study of Adult Development și lucrarea scrisă de Brené Brown, “Atlas of the Heart”.<br/><br/>Studiul de la Harvard, vechi de aproape 80 de ani, are ca scop înțelegerea a ce anume determină o viață fericită și plină de sens. Până în acest moment, studiul a demonstrat că îmbrățișarea comunității ne ajută să trăim mai mult și să fim mai fericiți. Secretul unei vieți îndelungate stă defapt în calitatea relațiilor. Dar cum putem avea relații calitative? Brené Brown pare să aibă răspunsul: prin empatie și conexiune autentică. În lucrarea sa, “Atlas of the Heart”, autoarea explică 4 etape ce ne pot aduce mai aproape de obținerea unei inteligențe emoționale ce creează comunități de oameni împreună: <b>perspective taking, staying out of judgement, recognise emotions, communication.</b><br/><br/>Dar ce înseamnă să participi la o experiență imersivă? Ruperea de realitate și pătrunderea într-o altă lume. Te ajută să te transpui și să descoperi noi trăiri și noi perspective de a privi lucrurile. Prin intermediul expoziției, ne putem imersa într-un context de relaționare prin care putem înțelege puterea relațiilor și a conexiunilor autentice în existența umană.<br/><br/>O experiență imersivă ne stimulează simțurile și ne transpune într-un alt loc sau într-o altă realitate. Are capacitatea de a ne face să „călătorim” în timp și spațiu, în trecut, prezent sau în viitor. Așadar,expoziția cu titlul „TOGETHERNESS” se prezintă asemenea descrierii anterioare – precum o experiență ce are capacitatea de a face vizitatorul să reflecteze asupra importanței relațiilor din viața sa prin parcurgerea spațiilor expoziționale, ce sunt organizate conform celor 4 etape descrise de Brené Brown.',
        imageCollection: [
            project2Image1,
            project2Image2,
            project2Image3,
            project2Image4,
            project2Image5,
            project2Image6,
            project2Image7,
            project2Image8
        ]
    },
    {
        id: '7',
        title: 'ALTERNATIVE TOGETHERNESS',
        thumbnail: project3Thumbnail,
        subtitle:
            'A fi împreună înseamnă pentru noi conexiune, viață, iubire, afecțiune, apropiere, atingere. ',
        creditsTo: 'Păun Bianca Maria',
        description:
            'Instalațiile propuse explorează modalități prin care oamenii conștientizează că sunt împreună prin intermediul principalelor simțuri - simțul vizual, simțul tactil și auditiv. Interacțiunea dintre oameni pare să fie din ce în ce mai limitată, tocmai de aceea propunerea potențează simțurile cu scopul de a conștientiza într-o manieră diferită prezența umană.<br /><br /> <b>WITH YOUR HEAD</b><br />În cadrul acestei instalații, vizitatorii pot să comunice doar prin intermediul privirii în momentul în care pătrund în nișă simultan prin punctele de acces. Cadrul vegetal neutru transpus la infinit reprezintă contextul întâlnirii dintre persoane și conectarea acestora la nivel vizual.<br /><br /><b>WITH YOUR HEART</b><br />Percepția tactilă a spațiului este influențată de numărul de persoane prezente simultan în cameră și tipul de mișcări pe care aceștia le întreprind, deplasând volumul de apă găzduit de baloane și mulându-se pe pieptul siluetelor alăturate. <br /><br /><b>WITH YOUR STEPS</b><br />Prezența în spațiu și orice tip de interacțiune umană este transpusă prin intermediul pardoselii la nivel sonor și mai apoi la nivel vizual. Fiecare mișcare a câte unui vizitator se face simțită de către ceilalți prin intermediul sunetului și a luminii. Fiecare mișcare compune spațiul și starea persoanelor prezente în cameră, inițial printr-o manifestare sonoră, iar ulterior o semnalizare luminoasă, vizuală.',
        imageCollection: [
            project3Image1,
            project3Image2,
            project3Image3,
            project3Image4,
            project3Image5,
            project3Image6,
            project3Image7,
            project3Image8,
            project3Image9,
            project3Image10
        ]
    }
];

export default projectsInfo